import type { ClassCardOptions } from '../../../../components/class-card/class-card.options';
import { Classroom } from '../../../../modules/classroom';
import { JourneyGrid } from '../../school-journeys';
import { JourneyCard } from '../journey-card/journey-card';

type Props = {
  journeys: Classroom[];
  isUpdatePeriod?: boolean;
  createJourneyOptions: (classroom: Classroom) => ClassCardOptions;
  onNavigateToClassroom: (classroomId: string) => void;
};

function SchoolJourneysList({
  journeys,
  isUpdatePeriod = false,
  createJourneyOptions,
  onNavigateToClassroom,
}: Props): JSX.Element | null {
  if (journeys.length === 0) {
    return null;
  }

  return (
    <JourneyGrid>
      {journeys.map((journey) => (
        <JourneyCard
          key={journey.id}
          journey={journey}
          isDisabled={isUpdatePeriod}
          options={createJourneyOptions(journey)}
          onClick={() => onNavigateToClassroom(journey.id)}
        />
      ))}
    </JourneyGrid>
  );
}

export { SchoolJourneysList };
